module.exports = __webpack_public_path__ + "static/media/instacart-short.9d4eb6b5.svg";